import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../../../helper/to_dangerous_react_html';
import { Rating } from '../../../rating/rating';
import FitterType from './overview/fitter_type';
import { Costs } from './overview/costs';
import Translation from '../../../translation/translation';
import Countdown from 'react-countdown';
import WheelsInfo from '../wheels_info';

function Overview(props) {
  const showAdditionalCosts = !!(props.totalShipping || props.calloutFee || props.wheelAlignment);
  const containerClassNames = ['fsf-station__overview', 'fsf-station-overview'];
  let containerStyles = {};
  let stationContentsStyles = {};
  const pageContainer = document.querySelector('.page-container');
  const isTyreShopsPage = pageContainer.classList.contains('tyreshops');
  const isMpsProduct = props.productStock !== null && true === props.productStock.isMpsProduct;
  const ratingAvg = parseFloat(Number(props.average).toFixed(1));
  let price =
    '<span style="font-size:16px; font-weight:normal">' + 'Fitting Price:' + '</span><br />' + props.totalPrice;
  if (TYROOLA.globals.fsFinderShowTotalCart) {
    price = props.totalCart;
  }

  if (props.showAllCosts) {
    containerClassNames.push('fsf-station-overview--show-single-items');
  }

  if (props.sponsored) {
    containerStyles = {
      border: `4px solid ${props.secondaryColor}`,
      borderRadius: '10px',
      padding: '0',
    };

    stationContentsStyles = {
      border: `4px solid ${props.primaryColor}`,
      borderRadius: '6px',
      padding: '0',
    };
  }
  const CountdownComplete = () => (
    <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
      <div className="fsf-station-overview__cell">
        <Translation translationKey="fitting-station-finder-overview-order-today-fitted-tomorrow" />
      </div>
    </div>
  );

  let dateObj = new Date();
  dateObj.setHours(23, 59, 0, 0);
  if (isMpsProduct) {
    if (props.mpsDoesSameDayFittingCutoff.length === 5) {
      let mpsCutoffTimeParts = props.mpsDoesSameDayFittingCutoff.split(':');
      dateObj.setHours(mpsCutoffTimeParts[0], mpsCutoffTimeParts[1], 0, 0);
    }
  }

  const countdownExpressOrderRenderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <CountdownComplete />;
    } else {
      // Render a countdown
      return (
        <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
          <div className="fsf-station-overview__cell">
            <Translation
              className="fsf-station-overview__express-order-label"
              translationKey="fitting-station-finder-overview-express-order-within"
              placeholder={{ countdownExpressHours: hours, countdownExpressMinutes: minutes }}
            />
          </div>
        </div>
      );
    }
  };

  const countdownOrderNowFitTomorrowRenderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <CountdownComplete />;
    } else {
      // Render a countdown
      return (
        <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
          <div className="fsf-station-overview__cell">
            <Translation
              translationKey="fitting-station-finder-overview-order-within-today-fitted-tomorrow"
              placeholder={{ countdownCutoffHours: hours, countdownCutoffMinutes: minutes }}
            />
          </div>
        </div>
      );
    }
  };
  return (
    <div className={containerClassNames.join(' ')} onClick={props.onDetailModeClick} style={{ padding: '5px' }}>
      <div className={containerClassNames.join(' ')} onClick={props.onDetailModeClick} style={containerStyles}>
        <div style={stationContentsStyles}>
          {props.sponsored && (
            <div className="justify-content-space-between align-items-center" style={{ padding: '10px 20px' }}>
              <img src={props.logoImage} alt="recommended-fitter" style={{ maxWidth: '100px' }} />
              <div style={{ fontWeight: '600' }}>Recommended Fitter</div>
            </div>
          )}
          {props.brandImage && (
            <div className="fsf-station-overview__row fsf-station-overview__row--brand-logo">
              <div className="fsf-station-overview__cell">
                <img src={props.brandImage} alt="" style={{ maxHeight: '30px' }} />
              </div>
              <div className="fsf-station-overview__cell" />
            </div>
          )}

          <div className="fsf-station-overview__row fsf-station-overview__row--address fsf-station-overview__row--fitting-costs">
            {!props.isMobileFitter ? (
              <div>
                <div className="fsf-station-overview__cell">
                  <div>{props.address}</div>
                  <div className="fsf-station__fitter-type fsf-station__fitter-type--display-name">
                    {props.displayName}
                  </div>
                  <Rating
                    starRating={{
                      stars: {
                        reviewCount: props.reviewCount,
                        average: ratingAvg,
                      },
                    }}
                  />
                </div>
                <div
                  className="fsf-station-overview__cell fsf-station-overview__cell--with-total-price"
                  dangerouslySetInnerHTML={toDangerousReactHtml(price)}
                />
              </div>
            ) : (
              <div>
                <div className="fsf-station-overview__cell">
                  {props.name || (
                    <Translation translationKey="fitting-station-finder-overview-overview-mobile-fitter-intro" />
                  )}
                  <Rating
                    starRating={{
                      stars: {
                        reviewCount: props.reviewCount,
                        average: ratingAvg,
                      },
                    }}
                  />
                </div>
                <div
                  className="fsf-station-overview__cell fsf-station-overview__cell--with-total-price"
                  style={{
                    fontSize: '20px',
                  }}
                >
                  <b dangerouslySetInnerHTML={toDangerousReactHtml(price)} />
                </div>
              </div>
            )}
          </div>

          <div className="fsf-station-overview__row fsf-station-overview__row--station-type">
            <div className="fsf-station-overview__cell">
              {!props.isMobileFitter && props.distance.toLowerCase() + ' '}
              <FitterType
                isMobileFitter={props.isMobileFitter}
                vehicleCollectAndReturnService={props.vehicleCollectAndReturnService}
              />
            </div>

            {!!props.productsQty ? (
              <Translation
                tagName="div"
                className="fsf-station-overview__cell fsf-station-overview__cell--tyre-amount"
                translationKey="fitting-station-finder-overview-tyre-amount"
                placeholder={{
                  amount: props.productsQty,
                }}
              />
            ) : (
              <div className="fsf-station-overview__cell" />
            )}

            {props.inDetailMode && props.isMarketplaceSeller && props.mpsDoesSameDayFitting && isMpsProduct && (
              <Countdown
                date={dateObj.getTime()}
                renderer={countdownExpressOrderRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
              />
            )}

            {props.inDetailMode && props.isMarketplaceSeller && !props.mpsDoesSameDayFitting && isMpsProduct && (
              <Countdown
                date={dateObj.getTime()}
                renderer={countdownOrderNowFitTomorrowRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
              />
            )}
          </div>
          {isTyreShopsPage && !props.inDetailMode && (
            <div className="fsf-station-overview__row">
              <WheelsInfo wheelsData={props.wheelsData} />
            </div>
          )}
          {!isTyreShopsPage && !props.inDetailMode && props.productsQty !== 0 && (
            <Costs
              wheelAlignment={props.wheelAlignment}
              wheelAlignmentWheelCount={props.wheelAlignmentWheelCount}
              wheelAlignment2IsShowable={props.wheelAlignment2IsShowable}
              wheelAlignment4IsShowable={props.wheelAlignment4IsShowable}
              totalShipping={props.totalShipping}
              calloutFee={props.calloutFee}
              totalCart={props.totalCart}
              etaFrom={props.etaFrom}
              etaTo={props.etaTo}
              onWheels2Change={props.onWheels2Change}
              onWheels4Change={props.onWheels4Change}
              tyreBrand={props.tyreBrand}
              staticUrl={props.staticUrl}
              store={props.store}
              isMarketplaceSeller={props.isMarketplaceSeller}
              isMpsProduct={isMpsProduct}
              mpsDoesSameDayFitting={props.mpsDoesSameDayFitting}
              mpsDoesSameDayFittingCutoff={props.mpsDoesSameDayFittingCutoff}
              fittingPromotion={props.fittingPromotion}
              disableFitter={props.disableFitter}
              allDiscounts={props.allDiscounts}
            />
          )}
        </div>
      </div>
    </div>
  );
}

Overview.propTypes = {
  address: PropTypes.string.isRequired,
  totalPrice: PropTypes.string.isRequired,
  totalCart: PropTypes.string.isRequired,
  reviewCount: PropTypes.number.isRequired,
  average: PropTypes.number.isRequired,
  onDetailModeClick: PropTypes.func.isRequired,
  onShowAllCostsClick: PropTypes.func.isRequired,
  onHideAllCostsClick: PropTypes.func.isRequired,
  showSelectStationButton: PropTypes.bool.isRequired,
  productsQty: PropTypes.number,
  tyreBrand: PropTypes.string,
  inDetailMode: PropTypes.bool,

  distance: PropTypes.string,
  totalShipping: PropTypes.string,
  calloutFee: PropTypes.string,
  etaFrom: PropTypes.instanceOf(Date),
  etaTo: PropTypes.instanceOf(Date),
  wheelAlignment: PropTypes.string,
  wheelsData: PropTypes.object,
  wheelAlignmentWheelCount: PropTypes.number,
  wheelAlignment2IsShowable: PropTypes.bool,
  wheelAlignment4IsShowable: PropTypes.bool,
  onWheels2Change: PropTypes.func.isRequired,
  onWheels4Change: PropTypes.func.isRequired,
  staticUrl: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  isMarketplaceSeller: PropTypes.bool,
  productStock: PropTypes.object,
  mpsDoesSameDayFitting: PropTypes.bool,
  mpsDoesSameDayFittingCutoff: PropTypes.string,
  vehicleCollectAndReturnService: PropTypes.bool,
  disableFitter: PropTypes.bool,
};

Overview.defaultProps = {
  disableFitter: false,
  productsQty: 0,
  tyreBrand: '',
  isMarketplaceSeller: false,
  mpsDoesSameDayFitting: false,
  productStock: null,
  vehicleCollectAndReturnService: false,
};

export default Overview;
